import React, { useState } from "react";
import { bool } from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import Button from "pages/_components/Button";
import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import Notification from "pages/_components/Notification";
import { actions as comexActions } from "reducers/comex";
// eslint-disable-next-line import/no-named-as-default
import ResponsiveHeader, { DesktopButtons, MobileButtons } from "pages/_components/header";
import Action from "pages/_components/Action";
import Image from "pages/_components/Image";
import I18n from "pages/_components/I18n";
import ComexStepper from "../_components/ComexStepper";
import Online from "./Online";
import FileTab from "./FileTab";

const StepComexClearance = ({ isDesktop }) => {
    const [isSaved, setIsSaved] = useState(false);
    const [data, setData] = useState(null);
    const { comexTransfer = {}, comexId = null } = useSelector((stateT) => stateT.comex);
    const comexTransferRequest = {
        ...comexTransfer,
        step: "stepCLEARANCE",
    };
    const { clearancesData = {} } = comexTransfer;
    const { type = "online" } = clearancesData;

    const initialTab = type === "online" ? 0 : 1;

    const dispatch = useDispatch();

    const tabsData = [
        {
            text: "comex.clearance.tab.online",
            textType: "I18N",
        },
        {
            text: "comex.clearance.tab.file",
            textType: "I18N",
        },
    ];

    const saveComexRequest = (isContinue) => {
        const _comexRequest = {
            ...comexTransferRequest,
            clearancesData: data,
            comexId,
            isContinue,
        };

        dispatch(comexActions.setComexTransfer(_comexRequest));
        dispatch(comexActions.createComexTransfer(_comexRequest));
        setIsSaved(true);
    };

    const handleSubmit = (value) => {
        /*
         * Se agrega el if para deshabilitar el botón guardar solicitud
         *   en caso de que se borren todos los agregados desde la tab online
         */
        if (
            value &&
            value.type === "online" &&
            value.clearances.filter((elem) => Object.keys(elem).length !== 0 || elem.deleted !== undefined).length === 0
        ) {
            setData(null);
        } else {
            setData(value);
        }
    };

    return (
        <>
            {isDesktop && <ComexStepper isDesktop={isDesktop} currentStep={4} />}
            <Notification scopeToShow="ComexNotification" />
            <ResponsiveHeader ticket metaTitle="transfers.comex.title" backLinkTo="/comex/transfer">
                <DesktopButtons>
                    <Button
                        className="btn btn-outline btn-block small"
                        onClick={() => {
                            saveComexRequest(false);
                        }}
                        disabled={isSaved || data === null}>
                        <Image
                            src={isSaved ? "images/figma/icon/check.svg" : "images/figma/icon/save.svg"}
                            className="icon-medium svg-icon"
                        />
                        <I18n id={isSaved ? "comex.transfer.save.ok.btn" : "comex.transfer.save.btn"} />
                    </Button>
                </DesktopButtons>
                <MobileButtons>
                    <Action
                        labelKey="comex.transfer.save.btn"
                        handleClick={() => saveComexRequest(false)}
                        disabled={data === null}
                    />
                </MobileButtons>
            </ResponsiveHeader>

            <div className="main-wrapper-comex-clearance">
                <CustomTabs defaultTab={initialTab} tabsData={tabsData} classNameRow="comex-clearance-custom-tabs-row">
                    <Online isDesktop={isDesktop} handleSubmit={(v) => handleSubmit(v)} />
                    <FileTab isDesktop={isDesktop} handleSubmit={(v) => handleSubmit(v)} />
                </CustomTabs>
            </div>
        </>
    );
};

export default StepComexClearance;

StepComexClearance.propTypes = {
    isDesktop: bool.isRequired,
};
